module.exports = __webpack_public_path__ + "static/media/logo_black-on-white-yellow-accent.37bebd6b.svg";